const getOfficeArea = (office, areas) => {
  const okato = office?.okato;

  if (!areas || !okato || okato.length !== 1) {
    return '';
  }

  const area = areas.find(areaFind => okato === areaFind.id);

  return area ? area.name : '';
};

export default getOfficeArea;
